import { useState, useEffect } from "react";
import Header from "../layout/header";
import { Loader } from "react-overlay-loader";
// import { axiosInstance } from "../config/https";
// import { toast } from "react-toastify";
// import { useNavigate, useParams } from "react-router-dom";
import { Card } from "react-bootstrap";

export default function EmailTemp() {
  const [loader, setLoader] = useState(false);
  //   const [, setData] = useState([]);
  //   const [errors, setErrors] = useState([]);
  //   const { id } = useParams();
  //   const navigate = useNavigate();

  //   const [, setMessage] = useState([]);
  //   const [email, setEmail] = useState("");
  //   const [cellNo, setCellNo] = useState("");
  //   const [addres, setAddres] = useState("");
  //   const [fName, setFName] = useState("");
  //   const [lName, setLName] = useState("");

  //   const handleContactus = async (e) => {
  //     e.preventDefault();
  //     const formData = new FormData();
  //     formData.append("first_name", fName);
  //     formData.append("last_name", lName);
  //     formData.append("email", email);
  //     formData.append("phone", cellNo);
  //     formData.append("address", addres);

  //     try {
  //       const response = await axiosInstance.post(`/update/user/${id}`, formData);

  //       console.log(response, "Success");
  //       if (response.data.status === true) {
  //         toast.success("Details submit successful");
  //         setMessage(response?.data?.message);
  //         setLName("");
  //         setFName("");
  //         setEmail("");
  //         setCellNo("");
  //         setAddres("");
  //         setErrors({});
  //         navigate("/user")
  //       } else {
  //         const apiErrors = response?.data?.data;
  //         if (apiErrors) {
  //           setErrors(apiErrors);
  //         } else {
  //           toast.error("Form Submission Failed");
  //         }
  //       }
  //     } catch (error) {
  //       toast.error(error?.response?.data?.message);
  //     }
  //   };

  //   useEffect(() => {
  //     GetUser();
  //   }, []);

  //   const GetUser = () => {
  //     setLoader(true);
  //     axiosInstance.get(`/edit/user/${id}`).then((response) => {
  //       setLoader(false);
  //       console.log("res", response);
  //       const { first_name, last_name, email, phone, address } = response?.data?.data;
  //       setFName(first_name);
  //       setLName(last_name);
  //       setEmail(email);
  //       setCellNo(phone);
  //       setAddres(address);

  //       if (response?.data?.status) {
  //         setData(response.data.data);
  //       } else {
  //         toast.warning(response?.data?.message);
  //       }
  //     });
  //   };

  return (
    <div>
      {loader === true ? <Loader fullPage loading /> : null}

      <Header />
      <div className="app-content content">
        <div className="content-wrapper">
          <div className="content-header row">
            <div className="content-header-left col-md-12 mb-2 breadcrumb-new">
              <h3 className="content-header-title mb-0 d-inline-block">
                Email Template
              </h3>
            </div>
          </div>
          <div className="content-body d-flex justify-content-center">
            <Card className="col-md-8">
              <Card.Body>
                <div
                  style={{
                    backgroundColor: "#f7f5fa",
                    margin: "0",
                    padding: "0",
                  }}
                >
                  <table
                    border="0"
                    cellPadding="0"
                    cellSpacing="0"
                    width="100%"
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#426899" align="center">
                          <table
                            border="0"
                            cellPadding="0"
                            cellSpacing="0"
                            width="480"
                          >
                            <tbody>
                              <tr>
                                <td
                                  align="center"
                                  valign="top"
                                  style={{ padding: "10px 10px 10px 10px" }}
                                ></td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td
                          bgcolor="#426899"
                          align="center"
                          style={{ padding: "0px 10px 0px 10px" }}
                        >
                          <table
                            border="0"
                            cellPadding="0"
                            cellSpacing="0"
                            width="480"
                          >
                            <tbody>
                              <tr>
                                <td
                                  bgcolor="#ffffff"
                                  align="left"
                                  valign="top"
                                  style={{
                                    padding: "30px 30px 20px 30px",
                                    borderRadius: "4px 4px 0px 0px",
                                    color: "#111111",
                                    fontFamily: "Helvetica, Arial, sans-serif",
                                    fontSize: "48px",
                                    fontWeight: "400",
                                    lineHeight: "48px",
                                  }}
                                >
                                  <h1
                                    style={{
                                      fontSize: "32px",
                                      fontWeight: "400",
                                      margin: "0",
                                    }}
                                  >
                                    E-Mail by Company
                                  </h1>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <table
                          width="100%"
                          border="0"
                          cellSpacing="0"
                          cellPadding="0"
                        >
                          <tbody>
                            <tr>
                              <th
                                align="left"
                                valign="top"
                                style={{
                                  padding: "15px 15px 10px 30px",
                                  fontFamily: "Helvetica, Arial, sans-serif",
                                  fontSize: "18px",
                                  fontWeight: "400",
                                  lineHeight: "25px",
                                }}
                              >
                                E-Mail
                              </th>
                              <td
                                align="left"
                                valign="top"
                                style={{
                                  padding: "15px 30px 10px 15px",
                                  fontFamily: "Helvetica, Arial, sans-serif",
                                  fontSize: "18px",
                                  fontWeight: "400",
                                  lineHeight: "25px",
                                }}
                              >
                                test@testemail.de
                              </td>
                            </tr>
                            <tr>
                              <th
                                align="left"
                                valign="top"
                                style={{
                                  padding: "15px 15px 10px 30px",
                                  fontFamily: "Helvetica, Arial, sans-serif",
                                  fontSize: "18px",
                                  fontWeight: "400",
                                  lineHeight: "25px",
                                }}
                              >
                                First Name
                              </th>
                              <td
                                align="left"
                                valign="top"
                                style={{
                                  padding: "15px 30px 10px 15px",
                                  fontFamily: "Helvetica, Arial, sans-serif",
                                  fontSize: "18px",
                                  fontWeight: "400",
                                  lineHeight: "25px",
                                }}
                              >
                                Max
                              </td>
                            </tr>
                            <tr>
                              <th
                                align="left"
                                valign="top"
                                style={{
                                  padding: "15px 15px 10px 30px",
                                  fontFamily: "Helvetica, Arial, sans-serif",
                                  fontSize: "18px",
                                  fontWeight: "400",
                                  lineHeight: "25px",
                                }}
                              >
                                Last Name
                              </th>
                              <td
                                align="left"
                                valign="top"
                                style={{
                                  padding: "15px 30px 10px 15px",
                                  fontFamily: "Helvetica, Arial, sans-serif",
                                  fontSize: "18px",
                                  fontWeight: "400",
                                  lineHeight: "25px",
                                }}
                              >
                                Mustermann
                              </td>
                            </tr>
                            <tr>
                              <th
                                align="left"
                                valign="top"
                                style={{
                                  padding: "15px 15px 10px 30px",
                                  fontFamily: "Helvetica, Arial, sans-serif",
                                  fontSize: "18px",
                                  fontWeight: "400",
                                  lineHeight: "25px",
                                }}
                              >
                                Phone
                              </th>
                              <td
                                align="left"
                                valign="top"
                                style={{
                                  padding: "15px 30px 10px 15px",
                                  fontFamily: "Helvetica, Arial, sans-serif",
                                  fontSize: "18px",
                                  fontWeight: "400",
                                  lineHeight: "25px",
                                }}
                              >
                                3152156678
                              </td>
                            </tr>
                            <tr>
                              <th
                                align="left"
                                valign="top"
                                style={{
                                  padding: "15px 15px 10px 30px",
                                  fontFamily: "Helvetica, Arial, sans-serif",
                                  fontSize: "18px",
                                  fontWeight: "400",
                                  lineHeight: "25px",
                                }}
                              >
                                Address
                              </th>
                              <td
                                align="left"
                                valign="top"
                                style={{
                                  padding: "15px 30px 10px 15px",
                                  fontFamily: "Helvetica, Arial, sans-serif",
                                  fontSize: "18px",
                                  fontWeight: "400",
                                  lineHeight: "25px",
                                }}
                              >
                                house no# 1/3 awin fileds Feld-Inhalt
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </tr>
                      {/* ... other rows of your HTML code ... */}
                      {/* For brevity, the rest of your HTML structure goes here */}
                      {/* Remember to convert all inline styles to React's style attribute */}
                    </tbody>
                  </table>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
